import { IncidentModel } from './incident.model';
import { FraudDocumentModel } from './fraud-document.model';

export class FraudModel extends IncidentModel {
    public incidentFraudId = 0;
    public investigatorName: string;
    public investigatorPhoneNumber: string;
    public fraudDocuments: FraudDocumentModel[] = [];
}
